<template>
  <main class="common-container">
    <section class="page-title flash-title">
      <h2>{{ $t("chart1.tradingView") }}</h2>
    </section>

    <section class="explanation-container center">
      <p class="center-sentence" v-html="$t('tvExp.descText1')"></p>
      <p class="center-sentence" v-html="$t('tvExp.descText2')"></p>
      <p class="center-sentence" v-html="$t('tvExp.descText3')"></p>
      <p class="center-sentence" v-html="$t('tvExp.descText4')"></p>
    </section>
  </main>
</template>

<style lang="scss" scoped>
@import "@/assets/scss/pages/explanation/common_explanation.scss";
</style>
